import React from 'react';
import DatePickerInput from 'react-datepicker';
import { ReactComponent as CelendarIcon } from 'resources/img/icons/calendar_today.svg';

const DatePicker = ({ ...props }) => {
  return (
    <div className="position-relative w-100">
      <DatePickerInput {...props} />
      <CelendarIcon className="position-absolute right-5px top-50 transform-center pointer-events-none" />
    </div>
  );
};

export default DatePicker;
